import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GrupoService } from '../../../../services/grupo.service';
import { EmpresaService } from '../../../../services/empresa.service';
import { FacturacionService } from '../../../../services/facturacion.service';
import { DeclaracionService } from '../../../../services/declaracion.service';
import { Grupo } from '../../../../models/grupo';
import { Facturacion } from '../../../../models/facturacion';
import { Declaracion } from '../../../../models/declaracion';

@Component({
	selector: 'app-declaracion',
	templateUrl: './declaracion.component.html',
	styleUrls: ['./declaracion.component.css'],
	providers: [GrupoService, EmpresaService, FacturacionService, DeclaracionService]
})
export class DeclaracionComponent implements OnInit {
	public identity;
	public token;
	public status;
	public message_success;
	public message_error;
	public message_alert;
	public section;
	public empresas;
	public empresa;
	public form: any = null;
	public declaracion: Declaracion;
	public facturacion: Facturacion;
	public grupo: Grupo;
	public inicio_declaracion;
	public fin_declaracion;
	public importe_derecho
	public ocupacion_declarada
	public importe_descuento
	public importe_actualizacion
	public importe_recargo
	public total_pagar

	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _grupoService: GrupoService,
		private _empresaService: EmpresaService,
		private _declaracionService: DeclaracionService,
		private _facturacionService: FacturacionService
	) {
		this.identity = this._grupoService.getIdentity();
		this.token = this._grupoService.getToken();
		this.grupo = new Grupo(1, 1, '', '', '', '', '', '', '', '', 1);
		this.declaracion = new Declaracion(1, 1, 0, 1, 1, 0, '', 0, '');
		this.facturacion = new Facturacion(0, 1, '', '', '', '', '', '', '', '', '');
	}

	ngOnInit() {
		this.getSection();
		this.getGrupo();
		this.getEmpresasByGrupo();
		this.getDeclaracion();
		$(".pagar").hide();
		$(".formaDeclarativa").hide();
	}

	formatterNumber(type) {

		if (type == 'money') {
			return new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
				minimumFractionDigits: 2
			})
		} else if (type == 'quantity') {
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2
			})
		}
	}


	getFormaDeclarativa(declaracion_id) {
		$(".formaDeclarativa").show();
		this._declaracionService.getFormaDeclarativa(this.token, declaracion_id).subscribe(
			response => {
				var url = response.url;
				window.open(url);
				setTimeout(function () {
					$(".formaDeclarativa").fadeTo(500, 1).slideUp(500, function () {
						$(".formaDeclarativa").hide();
					});
				}, 3000);
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					alert('Existen problemás con el servidor, favor de intentar más tarde')
					$(".formaDeclarativa").hide();
				}
			}
		)
	}

	getDeclaracion() {
		this._route.params.subscribe(params => {
			// convertir a entero
			let declaracion_id = +params['declaracion_id'];

			this._declaracionService.getDeclaracion(this.token, declaracion_id).subscribe(
				response => {
					// Obtener el token 
					if (response.status == 'success') {

						this.importe_derecho = this.formatterNumber('money').format(response.declaracion.importe_derecho)
						this.ocupacion_declarada = this.formatterNumber('quantity').format(response.declaracion.ocupacion_declarada)
						this.importe_descuento = this.formatterNumber('money').format(response.declaracion.importe_descuento)
						this.importe_actualizacion = this.formatterNumber('money').format(response.declaracion.importe_actualizacion)
						this.importe_recargo = this.formatterNumber('money').format(response.declaracion.importe_recargo)
						this.total_pagar = this.formatterNumber('money').format(response.declaracion.total_pagar)

						this.declaracion = response.declaracion;
						this.inicio_declaracion = response.inicio_declaracion
						this.fin_declaracion = response.fin_declaracion
					} else {
						alert('No se pueden cargar los datos porque usted no tiene conexión a internet');
					}
				},
				error => {
					if (error['status'] == 401) {
						this._router.navigate(['logout/1']);
					} else if (error['status'] == 403) {
						this._router.navigate(['dashboard/declaraciones']);
					} else {
						this.message_error = error;
					}
				}
			);
		});

	}

	eliminarDeclaracion(declaracion_id) {
		let objeto = { estatus: -1 }

		this._declaracionService.update(this.token, declaracion_id, objeto).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					alert('Se ha eliminado su declaración, sera redireccionado a sus declaraciones');
					window.location.href = "./dashboard/declaraciones";
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					alert('Tenemos un error con el servidor, intente más tarde');
				}
			}
		);
	}

	declararEnCero(image, declaracion_id) {

		let img: any = image.target;
		if (img.files.length > 0) {

			var form = new FormData();
			// indicamos que form contendra el valor de files en la posición 0
			form.append('image', img.files[0]);
			// Hacemos uso del servicio y adjuntamos la imagen

			this._declaracionService.declararCeros(this.token, form, declaracion_id).subscribe(
				response => {
					// Obtener el token 
					if (response.status == 'success') {
						alert('Se ha adjuntado el documento y enviado la declaración a revisión, será redireccionado a sus declaraciones');
						window.location.href = "./dashboard/declaraciones";
					}
				},
				error => {
					if (error['status'] == 401) {
						this._router.navigate(['logout/1']);
					} else if (error['error']['message']) {

						alert(error['error']['message'])

						setTimeout(function () {
							$(".dec").fadeTo(500, 1).slideUp(500, function () {
								$(".dec").hide();
							});
						}, 3000);
					} else {
						alert('Tenemos un error con el servidor, intente más tarde');
					}
				}
			);
		}
	}

	sendDeclaracion(declaracion_id) {

		if (this.form != null) {
			var banco_emisor = $("#banco_emisor").val();
			var referencia_bancaria = $("#referencia_bancaria").val();
			var fecha_pago = $("#fecha_pago").val();
			var monto_pago = $("#monto_pago").val();

			let obj = {
				'banco_emisor': banco_emisor,
				'referencia_bancaria': referencia_bancaria,
				'fecha_pago': fecha_pago,
				'monto_pago': monto_pago,
				'declaracion_id': declaracion_id
			}

			$(".loading").show();

			this._declaracionService.attachFileByDeclaracion(this.token, this.form, declaracion_id).subscribe(
				response => {
					// Obtener el token 
					if (response.status == 'success') {
						this._declaracionService.declarar(this.token, obj).subscribe(
							response => {
								// Obtener el token 
								if (response.status == 'success') {
									/* alert('Se ha enviado la declaración a revisión, será redireccionado a sus declaraciones');
									location.href = "./dashboard/declaraciones"; */
									$(".loading").hide();

									alert('Se ha adjuntado el documento y enviado la declaración a revisión, será redireccionado a sus declaraciones');
									window.location.href = "./dashboard/declaraciones";
								}
							},
							error => {
								$(".loading").hide();

								if (error['status'] == 401) {
									this._router.navigate(['logout/1']);
								} else {
									$(".dec").show();
									this.status = 'error';
									this.message_error = error['error']['message'];

									setTimeout(function () {
										$(".dec").fadeTo(500, 1).slideUp(500, function () {
											$(".dec").hide();
										});
									}, 3000);
								}
							}
						);

					}
				},
				error => {
					if (error['status'] == 401) {
						this._router.navigate(['logout/1']);
					} else if (error['error']['message']) {
						$(".loading").hide();
						$(".dec").show();
						this.status = 'error';
						this.message_error = error['error']['message'];

						setTimeout(function () {
							$(".dec").fadeTo(500, 1).slideUp(500, function () {
								$(".dec").hide();
							});
						}, 3000);
					} else {
						alert('Tenemos un error con el servidor, intente más tarde');
					}
				}
			);
		} else {
			$(".dec").show();
			this.status = 'error';
			this.message_error = 'Favor de adjuntar un archivo pdf que contenga su recibo';

			setTimeout(function () {
				$(".dec").fadeTo(500, 1).slideUp(500, function () {
					$(".dec").hide();
				});
			}, 3000);
		}
	}

	getFile(file) {
		let img: any = file.target;
		if (img.files.length > 0) {

			this.form = new FormData();
			this.form.append('image', img.files[0]);
		}
	}

	pay(pase_caja, total_pagar) {
		if (total_pagar > 80000) {
			return alert('El importe a pagar excede el monto autorizado por el banco')
		}
		$(".pagar").show();
		this._declaracionService.pay(this.token, pase_caja).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					var url = response.url;
					window.open(url);
					setTimeout(function () {
						$(".pagar").fadeTo(500, 1).slideUp(500, function () {
							$(".pagar").hide();
						});
					}, 3000);
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.message_error = error;
					setTimeout(function () {
						$(".pagar").fadeTo(500, 1).slideUp(500, function () {
							$(".pagar").hide();
						});
					}, 3000);
				}
				//this.message_error = error;
			}
		);
	}

	getSection() {
		this._route.params.subscribe(params => {
			// convertir a entero
			let section = params['section'];
			this.section = section;
		});
	}

	getGrupo() {
		this._grupoService.getGrupo(this.token, this.identity['sub']).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.grupo = response.grupo;
				} else {
					alert('No se pueden cargar los datos porque usted no tiene conexión a internet');
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.message_error = error;
				}
			}
		);
	}

	actualizar(form) {
		this._grupoService.actualizar(this.token, this.identity['sub'], this.grupo).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.status = response.status;
					this.grupo = response.grupo;
					this.message_success = response.message;
				} else {
					this.status = response.status;
					this.message_error = response.message;
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.message_error = error;
				}
			}
		);
	}

	getEmpresasByGrupo() {
		this._empresaService.getEmpresasByGrupo(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.empresas = response.empresas;
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.empresas = null;
					this.message_error = error;
				}

			}
		);
	}

}
